/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Professional/view.blocks to change it.
import React from 'react'
import Search from './Search/index'
import Term from './Term/index'



/** @type {import('Simple/types.js').View} */
export default function Professional({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/ReferralsSection/Add/Content/Templates/Content/Referral/Value/Search/Professional"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Professional.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Term
  viewPath={`${viewPath}/Term`}
/>
</div>
<Search
  viewPath={`${viewPath}/Search`}
/>
{children}
</React.Fragment>)
}